import React, { Component } from 'react'
import config from '../../config';
import { NavBar, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, FORMAT_NUMBER , CURRENCY } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import '../../css/responsive.css';
import { ApiClient } from "../../libs/apiClient";
import { DataTables } from "../../components";
let apiClient = ApiClient.getInstance();

const typeDocs = [
    { value: 'OITM', name: 'Articulo' },
    { value: 'ORDR', name: 'Pedido' },
    { value: 'OWTR', name: 'Traslado' },
];


class PrintTagsItemsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            typeDoc: 'OITM',
            docNum: '',
            groupNum: '',
            itemCode: '',
            ItmsGroups: [],
            lines: [],
            BranchOffices: [],
            checkboxDataTables: new Map(),
            project: ''
        }
    }

    componentDidMount = async () => {
        await this.GetItmsGroups();
        await this.GetBranchOffices();
    }

    GetBranchOffices = async () => {
        const data = { data: true }
        const responseApi = await apiClient.getSucursales(data);
        await this.setState({
            BranchOffices: responseApi?.data ?? []
        })
    }

    GetItmsGroups = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const GroupsItemData = await apiClient.getGroupsItemData();
        if (GroupsItemData.status !== 1) {
            showAlert({ type: 'warning', message: GroupsItemData.message });
            return;
        }
        this.ChangeAnyPropInState('ItmsGroups', GroupsItemData.data?.GrupoArticulo)
    }

    ChangeDocNum = (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Ingresa un valor valido por favor. Solo números' });
            return;
        }
        this.ChangeAnyPropInState('docNum', value)
    }

    ChangeTypeToSearch = (value) => {

        this.setState({
            typeDoc: value,
            docNum: '',
            groupNum: '',
            itemCode: '',
            lines: [],
        })
        // this.SearchResults();
    }

    ChangeAnyPropInState = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    SearchLinesByDoc = async () => {

    }

    ShowFieldsByTypeDoc = () => {
        const { typeDoc } = this.state
        switch (typeDoc) {
            case 'OITM':
                return this.renderFieldsItemsShow()
            case 'ORDR':
                return this.renderFieldsDocument();
            case 'OWTR':
                return this.renderFieldsDocument();
            default:
                return <div></div>;
        }


    }

    SearchResults = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { typeDoc, docNum, groupNum, itemCode, project, _user } = this.state

        if (typeDoc === 'OITM' && (!_user.hasOwnProperty("U_FMB_PLPrintTags") || _user.U_FMB_PLPrintTags === '')) {
            showAlert({ type: "info", message: `Tu sucursal no tiene asignada la lista de precios "Impresion de etiquetas". Informa a tu manager para solicitar su configuración en tu sucursal`, timeOut: 8500 });
            return
        }

        const data = {
            typeDoc,
            docNum,
            groupNum,
            itemCode,
            project,
            boPriceList: _user.U_FMB_PLPrintTags
        }

        enableSpinner(true);
        const responseApi = await apiClient.getDataToPrintTags(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        if (responseApi.data.length === 0) {
            showAlert({ type: "info", message: `NO ENCONTRAMOS INFO CON ESOS PARÁMETROS` });
            // return
        }

        this.setState({
            checkboxDataTables: new Map(),
            lines: responseApi.data ?? []
        });
    }

    SendToPrintData = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { checkboxDataTables, lines } = this.state
        let printInfoCodes = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value && (lines[id].CodeBars && lines[id].CodeBars !== '' && lines[id].CodeBars !== null)) {
                const Item = lines[id];
                const quantity = this.state.typeDoc === 'OITM' ? Item?.OnHand : Item.Quantity;
                const itemName = this.state.typeDoc === 'OITM' ? Item?.ItemName : Item.Dscription;
                const price = this.state.typeDoc === 'OWTR' ? Item.AvgPrice : Item.Price;
                const auxObject = {
                    CodeBar: Item.CodeBars,
                    ItemName: itemName,
                    Quantity: (quantity).toString() ?? 1,
                    SalUnitMsr: Item.SalUnitMsr ?? 'X',
                    Price: Number(price) ?? 0,
                    ItemCode: Item?.ItemCode ?? ''
                }
                printInfoCodes.push(auxObject);
            }
        }

        if (printInfoCodes.length === 0) {
            showAlert({ type: 'warning', message: "Seleccione información a imprimir" });
            return;
        }

        const data = {
            BarCodes: printInfoCodes
        }
        enableSpinner(true);
        await apiClient.PrintTags(data);
        enableSpinner(false);
    }


    ChangeItemGrpNum = async (value) => {
        await this.setState({
            groupNum: value,
            itemCode: ''
        })
        this.SearchResults();
    }

    ChangeBranchOffice = async (value) => {
        await this.setState({
            project: value
        })
        this.SearchResults();
    }

    ChangeItemCode = async (value) => {
        await this.setState({
            groupNum: '',
            itemCode: value
        })
    }

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id)); // toggle
            return { checkboxDataTables };
        });
    };

    toggleDocumentSelectedAll = (action) => {
        const { lines } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < lines.length; index++) {
            const register = lines[index];
            newCheckbox.set(index, action)
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    };



    render() {
        const { _user, typeDoc, lines, checkboxDataTables } = this.state
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));

        const checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }
        return (
            <div className='content'>
                <NavBar props={this.props} itemsDashboard={itemsDashboard} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'IMPRESIÓN DE ETIQUETAS DE ARTÍCULOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem" }}>
                    <div className="row m-3">
                        <h3 className="ml-3 mb-2 mt-3" id="refundModalLabel">Imprimir etiquetas de artículos</h3>
                    </div>
                    <div className="container-fluid mt-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row p-3 align-items-end">
                                    <div className="col-12 col-sm-6 col-md-3 mb-2">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon1">
                                                    <strong className="buscar">Buscar: </strong>
                                                </span>
                                            </div>
                                            <select
                                                id="toggleCostumer"
                                                className="form-control"
                                                style={{ minWidth: 0 }}
                                                onChange={(event) => this.ChangeTypeToSearch(event.target.value)}
                                                value={typeDoc}
                                            >
                                                <option value={''}>Seleccione una opción: </option>
                                                {
                                                    typeDocs.map((option, index) => {
                                                        return (
                                                            <option key={index + option} value={option.value.trim()}> {option.name}</option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    {this.ShowFieldsByTypeDoc()}


                                    <div className="col-12 col-sm-6 col-md-2 mb-2">
                                        <button type="button" className="btn buscar" onClick={() => this.SearchResults()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                            Buscar
                                        </button>
                                    </div>

                                </div>
                                <div className='m-3'>
                                    <div className='card scrollTableRePrint' >
                                        <table className="table table-striped table-hover">
                                            <thead className='sticky-headerPOS' style={{ background: "white" }}>
                                                <tr>
                                                    <th className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                            id="CheckAll"
                                                            onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                        />
                                                    </th>
                                                    <th className="text-center">Codigo</th>
                                                    <th className="text-center">Nombre</th>
                                                    <th className="text-center">Cantidad </th>
                                                    <th className="text-center">Codigo articulo</th>
                                                    <th className="text-center">Codigo barras</th>
                                                    <th className="text-center">Precio</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lines.map((item, index) => {
                                                    const quantity = this.state.typeDoc === 'OITM' ? item?.OnHand : item.Quantity;
                                                    const itemName = this.state.typeDoc === 'OITM' ? item?.ItemName : item.Dscription;
                                                    const price = this.state.typeDoc === 'OWTR' ? item.AvgPrice : item.Price;
                                                    return (
                                                        <tr key={index} style={{ maxHeight: 10, paddingTop: 8, paddingBottom: 8 }}>

                                                            {/* ROW */}
                                                            <td className="sticky-column" style={{ backgroundColor: '#FFF' }} onClick={() => checkbox.selectOne(index)}>
                                                                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2"
                                                                    checked={!!checkbox.data.get(index)} />
                                                            </td>
                                                            {/*ITEM CODE */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {item?.ItemCode ?? ""}
                                                            </td>
                                                            {/* NAME */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {itemName ?? ""}
                                                            </td>
                                                            {/* CANTIDAD */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {quantity ?? ''}
                                                            </td>
                                                            {/* ITEMCODE */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {item?.ItemCode ?? ""}
                                                            </td>
                                                            {/* BAR CODES */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {item?.CodeBars ?? ""}
                                                            </td>
                                                            {/* PRICE */}
                                                            <td className="overflow-visible" style={{ textAlign: 'center' }}>
                                                                {(CURRENCY + ' ' + FORMAT_NUMBER.new(price)) ?? ""}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>

                                        </table>

                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-12 col-md-10'>
                                    </div>
                                    <div className='col-12 col-md-2 text-rightc'>
                                        <button type="button" className="btn btn-primary" onClick={() => this.SendToPrintData()}>
                                            Imprimir
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        )
    }

    RenderTableByTypeDoc = () => {
        let table = <></>
        switch (this.state.typeDoc) {
            case 'OITM':
                table = this.TableItems()
                break;

            default:
                break;
        }
        return table;
    }

    TableItems = () => {
        return (
            <></>
        )
    }


    renderFieldsItemsShow = () => {
        const { groupNum, itemCode, ItmsGroups, BranchOffices } = this.state
        return (
            <>
                        <div className="col-12 col-sm-6 col-md-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Grupo: </strong></span>
                                </div>
                                <select
                                    id="toggleCostumer"
                                    className="form-control"
                                    style={{ minWidth: 0 }}
                                    onChange={(event) => this.ChangeItemGrpNum(event.target.value)}
                                    value={groupNum}
                                >
                                    <option value={''}>Seleccione una opción: </option>
                                    {
                                        ItmsGroups.map((option, index) => {
                                            return (
                                                <option key={index + option} value={option.ItmsGrpCod}> {option.ItmsGrpNam ?? ''}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>ItemCode: </strong></span>
                                </div>
                                <input
                                    type="text" className="form-control"
                                    style={{ minWidth: 0 }}
                                    value={itemCode ?? ''}
                                    onKeyDown={(ev) => { if (ev.key === 'Enter') { this.SearchResults() } }}
                                    onChange={(event) => this.ChangeItemCode(event.target.value)}
                                />
                        {/* <div className="col-12 col-sm-6 col-md-4 mb-1"> */}
                            {/* <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><strong>Suc: </strong></span>
                                </div>
                                <select
                                    id="toggleCostumer"
                                    className="form-control"
                                    onChange={(event) => this.ChangeBranchOffice(event.target.value)}
                                    value={this.state.project ?? ''}
                                >
                                    <option value={''}>Seleccione una opción: </option>
                                    {
                                        BranchOffices.map((option, index) => {
                                            return (
                                                <option key={index + option.nombre} value={option.project}> {option?.nombre ?? ''}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div> */}
                        {/* </div> */}

                    </div>
                </div>
            </>
        );
    }

    renderFieldsDocument = () => {
        const { docNum } = this.state
        return (
            <>
                        <div className="col-12 col-sm-6 col-md-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>DocNum: </strong></span>
                                </div>
                                <input
                                    type="text" className="form-control"
                                    style={{ minWidth: 0 }}
                                    value={docNum ?? ''}
                                    onKeyDown={(ev) => { if (ev.key === 'Enter') { this.SearchResults() } }}
                                    onChange={(event) => this.ChangeAnyPropInState('docNum', event.target.value)}
                                />
                    </div>
                </div>
            </>
        );
    }

    FieldsORDRShow = () => {
        const { docNum } = this.state
        return (
            <>
                <div className="col-12 col-sm-6 col-md-3 mb-2">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><strong>No. Documento: </strong></span>
                        </div>
                        <input
                            type="text" className="form-control"
                            style={{ minWidth: 0 }}
                            value={docNum ?? ''}
                            onKeyDown={(ev) => { if (ev.key === 'Enter') { this.SearchLinesByDoc() } }}
                            onChange={(event) => this.ChangeDocNum(event.target.value)}
                        />
                    </div>
                </div>
            </>
        );
    }


}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrintTagsItemsView);